'use client'

import { Button } from '@circlefin/components/lib/Button'
import { Icon } from '@circlefin/components/lib/Icon'
import { Link } from '@features/common.components/Link'
import useTranslation from 'next-translate/useTranslation'

import { getTokenDisplayName } from '../../containers/FaucetV2Container/TokenSelector'

import type { RequestTokenResponse } from '@features/faucet.graphql'

export interface RequestSuccessfulProps {
  /**
   * Response received from the request token call.
   */
  data: RequestTokenResponse
  /**
   * Callback that will be invoked, when the user clicks the get more tokens button.
   */
  onReset: () => void
}
export const RequestSuccessful: React.FC<RequestSuccessfulProps> = ({
  data,
  onReset,
}) => {
  const { t } = useTranslation('faucet')
  return (
    <div className="flex w-full flex-col space-y-4">
      <Icon.Circle intent="success" name="CheckCircleSolid" />
      <h3 className="type-header-xl">{t`requestSuccessful.headline`}</h3>
      <p className="type-body-2xl">
        {t('requestSuccessful.description', {
          amount: data.amount,
          currency: getTokenDisplayName(data.currency),
        })}
      </p>
      {data.explorerLink ? (
        <Link
          className="inline-block overflow-hidden text-ellipsis"
          path={data.explorerLink}
          type="external"
        >
          {data.explorerLink}
        </Link>
      ) : null}
      <Button className="w-58" onClick={onReset} size="lg" variant="primary">
        {t`requestSuccessful.getMore`}
      </Button>
    </div>
  )
}
